/*
 * Copyright (C) Zoomdata, Inc. 2012-2022. All rights reserved.
 */
import { ComponentTypes } from './types';
const commonEntrypoint = {
    constructorName: 'Zoomdata',
    bundleName: 'app/logi-composer.js',
    singleInitialization: true,
};
const inventoryEntrypoint = {
    constructorName: 'ComposerInventory',
    bundleName: 'app/logi-inventory.js',
    singleInitialization: false,
};
const sourceEditorEntrypoint = {
    constructorName: 'ComposerSourceEditor',
    bundleName: 'app/logi-source-editor.js',
    singleInitialization: false,
};
export const embedComponentEntrypoints = {
    [ComponentTypes.DASHBOARD]: commonEntrypoint,
    [ComponentTypes.VISUAL_BUILDER]: commonEntrypoint,
    [ComponentTypes.LITE_DASHBOARD]: commonEntrypoint,
    [ComponentTypes.INVENTORY]: inventoryEntrypoint,
    [ComponentTypes.SOURCE_EDITOR]: sourceEditorEntrypoint,
};
//# sourceMappingURL=entrypoints.js.map